import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from '../../ui/button/button.component';

@Component({
  selector: 'app-email-otp-prompt',
  standalone: true,
  imports: [CommonModule, FormsModule, ButtonComponent],
  templateUrl: './email-otp-prompt.component.html'
})
export class EmailOtpPromptComponent {
  @Input() loading = false;
  @Input() errorMessage = '';
  @Input() emailHint?: string;
  /** Seconds until the code expires (from send response). Optional countdown / hint. */
  @Input() expiresInSeconds?: number;
  /** When > 0, Resend is disabled and UI can show "Resend available in Xs" (from 429 rate limit). */
  @Input() resendCooldownSeconds?: number;
  /** When false, send has not succeeded yet — disable Verify to avoid "No verification code found" from backend. */
  @Input() sendSucceeded = true;
  @Output() codeSubmit = new EventEmitter<string>();
  @Output() back = new EventEmitter<void>();
  @Output() resend = new EventEmitter<void>();

  code = '';

  private isRateLimitMessage(message: string): boolean {
    return /please\s+wait\s+\d+\s*seconds?/i.test(message || '');
  }

  get shouldShowError(): boolean {
    // Don't render rate-limit "please wait X seconds" as an error banner; the resend cooldown already communicates it.
    return !!this.errorMessage && !this.isRateLimitMessage(this.errorMessage);
  }

  /** Digits only from code (for template – avoids regex in template). */
  get codeDigits(): string {
    return this.code.replace(/\D/g, '');
  }

  onCodeInput(raw: string): void {
    this.code = raw.replace(/\D/g, '').slice(0, 6);
  }

  submit(): void {
    const digits = this.codeDigits.slice(0, 6);
    if (digits.length !== 6) {
      return;
    }
    this.codeSubmit.emit(digits);
  }

  goBack(): void {
    this.back.emit();
  }

  onResend(): void {
    this.resend.emit();
  }
}
